import React from 'react';
import { TreeSelect as DesignTreeSelect } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const TreeSelect = (props: any) => {
  const { element, elementStyle } = props;
  const { formSettings, formItemSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  const { treeData, autoInitialize,treeNodeFilterProp } = formItemSettings;
  const flatData = []

  function getFlat(arr){
    if(arr.length){
      arr.map(item=>{
        flatData.push({...item})
        if(item.children?.length){
          const titles=item.titles?[...item.titles]:[item[treeNodeFilterProp]]
          getFlat(item.children.map(ele=>({...ele,titles:[...titles,ele[treeNodeFilterProp]]})))
        }
      })
    }
  }
  getFlat(treeData)

  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DesignTreeSelect
        filterTreeNode={(input, option) => {
          if(option.props[treeNodeFilterProp]===null||option.props[treeNodeFilterProp]===undefined){
            return true
          }
          const titles=flatData.find(item=>item.key===option.key).titles||[flatData.find(item=>item.key===option.key)[treeNodeFilterProp]]
          return titles.some(item=>item.toLowerCase().indexOf(input.toLowerCase())>=0)
        }}
        {...formItemSettings}
        className={className}
        treeData={autoInitialize ? treeData : []}
      />
    </FormItem>
  );
};

export default TreeSelect;
